import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControllerComponent} from '../../../../Controller/controller-component';
import {DeliveryNoteDto} from '../../../../../Models/Purchases/Delivery-notes/delivery-note.interface';
import {OrderDto} from '../../../../../Models/Purchases/Orders/order.interface';

@Component({
  selector: 'app-add-product-item',
  templateUrl: './add-product-item.component.html',
  styleUrls: ['./add-product-item.component.scss'],
  standalone: false
})
export class AddProductItemComponent extends ControllerComponent {
  @Input() data!: DeliveryNoteDto | OrderDto;

  @Input() item: any;
  @Input() locked: boolean = false;
  @Input() onlyNegativeQuantity: boolean = false;

  @Output() itemChange: EventEmitter<void> = new EventEmitter<void>();
  @Output() configureClick: EventEmitter<void> = new EventEmitter<void>();
}
